import React from 'react';
import { Users, Clock, TrendingUp } from 'lucide-react';

const resources = [
  {
    name: 'Team Utilization',
    value: '85%',
    change: '+2.3%',
    icon: Users,
    color: 'text-blue-600',
    bg: 'bg-blue-100',
  },
  {
    name: 'Project Hours',
    value: '156h',
    change: '+12.5%',
    icon: Clock,
    color: 'text-purple-600',
    bg: 'bg-purple-100',
  },
  {
    name: 'Efficiency Rate',
    value: '92%',
    change: '+4.2%',
    icon: TrendingUp,
    color: 'text-green-600',
    bg: 'bg-green-100',
  },
];

export function ResourceUtilization() {
  return (
    <div>
      <h2 className="text-lg font-medium text-gray-900">Resource Utilization</h2>
      <div className="mt-6 grid gap-6">
        {resources.map((resource) => {
          const Icon = resource.icon;
          return (
            <div key={resource.name} className="flex items-center justify-between">
              <div className="flex items-center">
                <div className={`rounded-lg ${resource.bg} p-3`}>
                  <Icon className={`h-6 w-6 ${resource.color}`} />
                </div>
                <div className="ml-4">
                  <p className="text-sm font-medium text-gray-500">{resource.name}</p>
                  <div className="mt-1">
                    <span className="text-2xl font-semibold text-gray-900">{resource.value}</span>
                    <span className="ml-2 text-sm font-medium text-green-600">{resource.change}</span>
                  </div>
                </div>
              </div>
              <div className="h-2 w-24 rounded-full bg-gray-200">
                <div
                  className={`h-2 rounded-full bg-${resource.color.split('-')[1]}-600`}
                  style={{ width: resource.value }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}